// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
const loadImages = require("%helpers%/load-images.js");
// -- Helpers END


// -- Libraries BEGIN
import swiper from "swiper";
// -- Libraries END


windowLoad(function() {

	const sliderData = {
		element: $(".sec-videos-slider__swiper"),
		arrows: {
			all: $(".sec-videos-slider__swiper .slider-arrows__arrow"),
			prev: $(".sec-videos-slider__swiper .slider-arrows__arrow_prev"),
			next: $(".sec-videos-slider__swiper .slider-arrows__arrow_next"),
		},
	};

	const swiperData = {
		spaceBetween: 20,
		speed: 800,
		loop: false,
		slidesPerView: 4,
		autoHeight: true,
		navigation: {
			prevEl: sliderData.arrows.prev,
			nextEl: sliderData.arrows.next,
		},
		breakpoints: {
			320: {
				slidesPerView: "auto",
				spaceBetween: 12,
			},
			768: {
				slidesPerView: "auto",
				spaceBetween: 12,
			},
			992: {
				slidesPerView: "auto",
				spaceBetween: 20,
			},
			1366: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1400: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		}
	};

	// -- Functions BEGIN
	const sliderInit = () => {
		new swiper(sliderData.element, swiperData);
	};
	// -- Functions END


	if (sliderData.element.length) sliderInit();

});

